import Vue from 'vue'
import axios from 'axios'
import moment from 'moment';

import App from './App'
import router from './router'
import WinApp from './winapp'

export const EventBus = new Vue();

Vue.config.productionTip = false

Vue.http = axios
Object.defineProperties(Vue.prototype, {
  http: { get () { return axios } },
  $http: { get () { return axios } },
  $winapp: { get() { return WinApp; } },
  $moment: { get() { return moment; } }
});

/* eslint-disable no-new */
new Vue({
  router,
  ...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js